<template>
  <div class="lad-reviews--comments">
    <LadLimiter
      v-if="comments.length > 0"
      :component="$options.components.LadReviewComment"
      :items="comments"
      hide-less-btn
      :steps="10"
      btn-block
      inverse
    />
  </div>
</template>

<script>
import LadReviewComment from './comment'

export default {
  name: 'LadReviewComments',
  components: {
    // eslint-disable-next-line vue/no-unused-components
    LadReviewComment,
    LadLimiter: () =>
      import(/* webpackChunkName: "lad-limiter" */ '@/components/limiter'),
  },
  props: {
    comments: { type: Array, default: () => [] },
  },
}
</script>

<style lang="scss">
.lad-reviews--comments {
  margin-top: 10px;

  .el-card {
    border: 1px solid #ebeef5;
    border-radius: 5px;

    & + .el-card {
      margin-top: 6px;
    }
  }
}
</style>
